/// <amd-module name="typeahead/features/KnowYourCustomerOriginAirport" />

"use strict";

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult, SuggestionCategory} from "typeahead/core/Suggestion";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const featureFlag: string = "home_airport";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "FlightsLandingPage"],
        deviceTypes: ["Desktop"],
        experiment: {
            id: 26321,
            name: "KYC_Storefront_Flight_Origin_Prefilled",
        },
        lobs: ["FLIGHTS"],
        locales: ["en_US"],
    },
];

export class KnowYourCustomerOriginAirport implements ISuggestionsModifier, IExperimentalFeature,
    IRequestUrlParamModifier {
    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any): object[] {
        if (suggestions && suggestions.length > 0 && ExecutionHelper.shouldExecute(context, configuration)) {
            suggestions.forEach((suggestion: IEssSuggestionResult, index: number): void => {
                if (suggestion.category === SuggestionCategory[SuggestionCategory.HOMEAIRPORT]) {
                        suggestion.displayGroup = {
                            groupName: "kycHomeAirport",
                            label: "Your home airport",
                        };
                }
            });
        }
        return suggestions;
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        if (options.gcwStoreableName === "gcw-origin") {
            return addFeatureFlag(featureFlag, configuration, params, context, options);
        }
        return params;
    }
}
